import { FormsConstants } from './forms-constants';
import { TypeFilter } from './type-filter';

export type FormTypeFilters = Readonly<{ [key in FormsConstants.ELEMENT_TYPE]: TypeFilter }>;

export const initialFormTypeFilters: FormTypeFilters = {
    [FormsConstants.ELEMENT_TYPE.A]: {
        elementType: FormsConstants.ELEMENT_TYPE.A,
        label: 'Label A',
        visible: false,
        active: true,
    },
    [FormsConstants.ELEMENT_TYPE.B]: {
        elementType: FormsConstants.ELEMENT_TYPE.B,
        label: 'Label B',
        visible: false,
        active: true,
    },
    [FormsConstants.ELEMENT_TYPE.C]: {
        elementType: FormsConstants.ELEMENT_TYPE.C,
        label: 'Label C',
        visible: false,
        active: true,
    },
    [FormsConstants.ELEMENT_TYPE.D]: {
        elementType: FormsConstants.ELEMENT_TYPE.D,
        label: 'Label D',
        visible: false,
        active: true,
    },
    [FormsConstants.ELEMENT_TYPE.E]: {
        elementType: FormsConstants.ELEMENT_TYPE.E,
        label: 'Label E',
        visible: false,
        active: true,
    },
    [FormsConstants.ELEMENT_TYPE.F]: {
        elementType: FormsConstants.ELEMENT_TYPE.F,
        label: 'Label F',
        visible: false,
        active: true,
    },
    [FormsConstants.ELEMENT_TYPE.STANDARD]: {
        elementType: FormsConstants.ELEMENT_TYPE.STANDARD,
        label: 'Standard',
        visible: false,
        active: true,
    },
    [FormsConstants.ELEMENT_TYPE.QUALITY]: {
        elementType: FormsConstants.ELEMENT_TYPE.QUALITY,
        label: 'Quality',
        visible: false,
        active: true,
    },
    [FormsConstants.ELEMENT_TYPE.SOFTWARE]: {
        elementType: FormsConstants.ELEMENT_TYPE.SOFTWARE,
        label: 'Software',
        visible: false,
        active: true,
    },
    [FormsConstants.ELEMENT_TYPE.SAFETY]: {
        elementType: FormsConstants.ELEMENT_TYPE.SAFETY,
        label: 'Safety',
        visible: false,
        active: true,
    },
    [FormsConstants.ELEMENT_TYPE.TIME]: {
        elementType: FormsConstants.ELEMENT_TYPE.TIME,
        label: 'Time',
        visible: false,
        active: true,
    },
    [FormsConstants.ELEMENT_TYPE.MATERIAL]: {
        elementType: FormsConstants.ELEMENT_TYPE.MATERIAL,
        label: 'Material',
        visible: false,
        active: true,
    },
    [FormsConstants.ELEMENT_TYPE.UNKNOWN]: {
        elementType: FormsConstants.ELEMENT_TYPE.UNKNOWN,
        label: 'Unknown',
        visible: false,
        active: true,
    },
};
